// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"246":"631d02f6c88cc101","842":"1b17fe882f561772"}[chunkId] + ".js";
};